import DateTime from "./datetime.js";

export { DateTime };

export function parseDate(value) {
  const dateTimeParsers = [
    DateTime.fromISO,
    DateTime.fromRFC2822,
    DateTime.fromHTTP,
    DateTime.fromSQL,
  ];

  if (!value) return undefined;
  if (typeof value !== "string") return undefined;

  for (const parser of dateTimeParsers) {
    const parsed = parser(value, { zone: "utc" });
    if (parsed.isValid) {
      return parsed.toJSDate();
    }
  }
  return undefined;
}
